/* eslint-disable react-hooks/exhaustive-deps */
import { AgGridReact } from 'ag-grid-react';
import React, { useContext, useEffect, useMemo, useState } from "react";
import "../../CSS/general.css";
import AlertModal from "../MainComponents/AlertMessagePopup";
import ActionButtons from "./ActionButton";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import AuthenticationContext from "../../Store/Authentication-Context";
import Axios from "axios";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import LoaderGif from "../../images/365 loading.gif";

const Step2 = (props) => {
    const { setAuthContext } = useContext(AuthenticationContext);
    const [disabled, setDisabled] = useState(true);
    const alertMessage = {
        header: "",
        message: "",
    };
    //const [alertMessage, setAlertMessage] = useState({
    //    header: "",
    //    message: "",
    //});
    const [AlertPop, setAlertPop] = useState(true);
    ////const [gridApi, setGridApi] = useState([]);
    const [companyContacts, setCompanyContacts] = useState(null);


    const validate = async () => {
        try {
            setDisabled(true);
            await updateContactInCloudcover();
            await updateContactInConnectWise();
            setTimeout(() => {
                props.nextStep();
            }, 100);

        } catch (error) {
            console.error("Error in creating contacts or agreements:", error);

        };

    }

    async function getCWandCloudCoverContacts() {
        var tokenString = await setAuthContext("", new Date());

        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        await Axios.get(API_ROUTE + Routes.GET_CONNECTWISE_CLOUDCOVER_CONTACTS, config)
            .then((response) => {
               
                setDisabled(false);
                if (response && response.data) {
                    let responsedata = response.data;
                    setCompanyContacts (responsedata);
                }

            })
            .catch((reason) => {
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }

            });
    }

    const renderTooltip = (props) => (

        <Tooltip id={`tooltip-${props.id}`} {...props}>
            {props.text}
        </Tooltip>

    );


    const defaultColDef = useMemo(() => ({
        sortable: true,
        resizable: true, flex: 1
    }), []);
   

    function cancelAlertClick() {
        setAlertPop(true);
    }
    async function updateContactInCloudcover() {

        if (companyContacts) {

            const filteredContacts = companyContacts.filter(contact =>
                contact.update === 1
            );

            for (const contact of filteredContacts) {
               
                let apiRoute = contact.emailType === 'Billing' ? Routes.SET_ADMIN_EMAIL : Routes.SET_NOTIFICATION_EMAIL;

        // Make the API call to update the setting on the server
        try {
            const tokenString = await setAuthContext("", new Date());
            const config = {
                headers: {
                    Authorisation: `Bearer ${tokenString}`,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };

            await Axios.patch(API_ROUTE + apiRoute + '/' + contact.orgId + '/' + contact.cwEmailId , "", config)
                        .then((response) => {


                        })
                        .catch((reason) => {
                            console.error("Error updating emailid:", reason);
                        });
                } catch (error) {
                    console.error("Error in handleCellValueChanged:", error);
                }
            }
        }
        
    }
    async function updateCloudCoverContact(params) {

                    const updatedLines = companyContacts.map(line => {
                        if (line.orgId === params.data.orgId && line.emailType === params.data.emailType && params.data.cwCompanyId === line.cwCompanyId) {
                            return { ...line, email: params.data.cwEmailId ,update:1};
                        }
                        else {
                            return line;
                        }
                    });
              
                    setCompanyContacts(updatedLines);

    }

    async function updateContactInConnectWise() {
        if (companyContacts) {
            const createContacts = [];

            const filteredContacts = companyContacts.filter(contact =>
                ((contact.updateCC === 1 && contact.emailType === 'Billing') || (contact.emailType === 'Billing' && (contact.contactId === 0 || contact.cwAgreementId === 0)))
            );

            filteredContacts.forEach(contact => {
                // Extract the first name from the email
                const firstNameFromEmail = contact.email.split('@')[0]; // Adjust logic if needed

                const newContact = {
                    id: 0,
                    orgId: contact.orgId,
                    orgName: contact.orgName,
                    EffectiveDate: contact.effectiveDate,
                    cwAgreementId: contact.cwAgreementId,
                    IsChanged: contact.updateCC === 1?1:0,
                    agreementType: contact.cWAgreementID,
                    firstName: firstNameFromEmail,
                    company: {
                        id: contact.cwCompanyId,
                    },
                    relationship: {
                        id: 2,
                        name: 'Payments',
                    },
                    defaultBillingFlag: contact.emailType === 'Billing',
                    communicationItems: [
                        {
                            id: 0,
                            type: {
                                id: 1,
                                name: "Email - Work",
                            },
                            value: contact.email,
                            defaultFlag: contact.emailType === 'Billing',
                            communicationType: 'Email',
                        },
                    ],
                    types: [
                        {
                            id: contact.emailType === 'Billing' ? props.typesIds.billingTypeId : props.typesIds.notificationTypeId,
                            name: contact.emailType === 'Billing' ? "Billing Contact" : "CC365 Notification",
                        },
                    ],
                };

                createContacts.push(newContact);
            });

            const notificationdContacts = companyContacts.filter(contact =>
                ((contact.updateCC === 1 && contact.emailType === 'CCNotifications') || (contact.emailType === 'CCNotifications' && (contact.contactId === 0 )) )
            );

            notificationdContacts.forEach(contact => {
                // Extract the first name from the email
                const firstNameFromEmail = contact.email.split('@')[0]; // Adjust logic if needed 

                const newContact = {
                    id: 0,
                    firstName: firstNameFromEmail,
                    IsChanged: contact.updateCC === 1 ? 1 : 0,
                    company: {
                        id: contact.cwCompanyId,
                    },
                    defaultBillingFlag: contact.emailType === 'Billing',
                    communicationItems: [
                        {
                            id: 0,
                            type: {
                                id: 1,
                                name: "Email - Work",
                            },
                            value: contact.email,
                            defaultFlag: contact.emailType === 'Billing',
                            communicationType: 'Email',
                        },
                    ],
                    types: [
                        {
                            id: contact.emailType === 'Billing' ? props.typesIds.billingTypeId : props.typesIds.notificationTypeId,
                            name: contact.emailType === 'Billing' ? "Billing Contact" : "CC365 Notification",
                        },
                    ],
                };

            createContacts.push(newContact);
        });
        const tokenString = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ${tokenString}`,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

            try {

                await Axios.post(API_ROUTE + Routes.CREATE_CONNECTWISE_CONTACT, createContacts, config)
                    .then((response) => {
                  
                        if (response && response.data && response.data !== "" && response.data.length > 0) {

                            props.updateAggreements(response.data);
                        }
                    })
                    .catch((error) => {
                        console.error("Error creating contact:", error);
                    });


            } catch (error) {
                console.error("Error in CreateContacts:", error);
                if (error?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            }

            //await createConnectWiseAgreements(contacts);
        }
    }

    async function updateConnectWiseContact(params) {


        const updatedLines = companyContacts.map(line => {
            if (line.orgId === params.data.orgId && line.emailType === params.data.emailType && params.data.cwCompanyId === line.cwCompanyId) {
                return { ...line, cwEmailId: params.data.email, updateCC: 1 };
            }
            else {
                return line;
            }
        });

        setCompanyContacts(updatedLines);

       
    }

    
    const columnDefs = [
        {
            field: 'orgName',
            headerName: 'Company Name',
            width: 200,
        },
        {
            headerName: "Connect Wise", headerClass: "center-header",
            children: [
                { field: 'cwContactName', headerName: 'Contact Name', width: 150, },
                { field: 'cwEmailId', headerName: 'Email Address', width: 140, },
                { field: 'emailType', headerName: 'Type', width: 140, }
            ]
        },

        {
            headerName: 'Update',
            width: 70,

            editable: false,
            cellRenderer: (params) => {

                return (
                    <div className="justify-content-between d-flex align-items-center">

                        <button onClick={() => updateConnectWiseContact(params)} className={params.data.email ? 'a-icon' : 'disabled-link a-icon'}
                            style={params.data.email ? {} : { pointerEvents: 'none', opacity: 0.5 }}
                        >
                            <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Manage Organisation" })}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.293 3.293 6.586 12l8.707 8.707 1.414-1.414L9.414 12l7.293-7.293-1.414-1.414z" /></svg>
                            </OverlayTrigger>
                        </button>


                        <button onClick={() => updateCloudCoverContact(params)} className={params.data.cwEmailId ? 'a-icon' : 'disabled-link a-icon'}
                            style={params.data.cwEmailId ? {} : { pointerEvents: 'none', opacity: 0.5 }}
                        >
                            <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Manage Organisation" })}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" /></svg>
                            </OverlayTrigger>
                        </button>

                    </div>
                );
            },
        },
        
        {
            headerName: "CloudCover", headerClass: "center-header",
            children: [
                { field: 'contactName', headerName: 'Contact Name', width: 150, },
                { field: 'email', headerName: 'Email Address', width: 140, },
                { field: 'emailType', headerName: 'Type', width: 140, },
            ]
        },
     
        
       
    ];
    const gridOptions = {
        getRowId: (params) => params.data.id,        
        isExternalFilterPresent: () => true,
        doesExternalFilterPass: (node) => {
            const cwEmail = node.data.cwEmailId ? node.data.cwEmailId.toLowerCase() : '';
            const email = node.data.email ? node.data.email.toLowerCase() : '';
            return cwEmail !== email || (node.data.update === 1 || node.data.updateCC ===1);
        }
    };
    const onGridReady = (params) => {
        //setGridApi(params.api);
        if (params && params.api)
        {
            params.api.onFilterChanged();
        }
    }

    useEffect(() => {
        let isMounted = true;
        if (isMounted===true) {
            getCWandCloudCoverContacts();
        }
        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <div id="step2">
            <div>
                <div id="UpdatePanel1">
                    <div className="card">
                        <h4 className="card-header ">
                            <span id="TitleLabel" className="SectionTitle">Check Contacts&nbsp;</span>
                            
                        </h4>
                        <div className="card-body" style={{ borderStyle: "None", height: "400px", width: "100%" }}>
                            <div className="ag-theme-alpine ms-2 cw-get-contacts" style={{ borderColor: "#F0F0F0", borderStyle: "Solid", width: "99%", height: '100%', overflowY: "auto" }}>

                                {disabled === true ?
                                    <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '35vh' }}>
                                        <img src={LoaderGif} alt="loading" style={{ height: '70px' }} />
                                        <span className="visually-hidden">Loading...</span>
                                    </div> :
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={companyContacts}
                                        isExternalFilterPresent={() => true}
                                        doesExternalFilterPass={(node) => {
                                            const cwEmail = node.data.cwEmailId?.toLowerCase() ?? '';
                                            const email = node.data.email?.toLowerCase() ?? '';
                                            return cwEmail !== email || node.data.update === 1 || node.data.updateCC === 1;
                                        }}
                                        onGridReady={onGridReady}
                                        defaultColDef={defaultColDef}
                                        domLayout="normal"
                                        floatingFiltersHeight={0}
                                        overlayLoadingTemplate={
                                            `<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><div><div style="text-align: center;"><img src="${LoaderGif}" alt="loading" style="height: 50px;"></div><span>Please wait while your rows are loading...</span></div></div>`}
                                    />
                                }
                            </div>
                        </div>
                        <div>
                            <table cellSpacing="5" cellPadding="5" align="right">
                                <tbody>
                                    <tr>
                                        <td align="right">
                                            <ActionButtons {...props} isDisabled={disabled} nextStep={validate} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <AlertModal displayModal={!AlertPop} closeModal={cancelAlertClick} message={alertMessage} />
        </div>
    );
}

export default Step2;
